export default "__VITE_ASSET__nxlyPAQo__"